import React, { useEffect, useRef, useState } from "react";
import _ from "lodash";

const PasswordResetSuccessfull = ({ onTimerComplete }) => {
  const [count, setCount] = useState(3);

  const countRef = useRef(null);
  countRef.current = count;

  const timerRef = useRef(null);
  useEffect(() => {
    timerRef.current = setInterval(() => {
      if (countRef.current === 0) {
        onTimerComplete?.();
        clearInterval(timerRef.current);
        return;
      } else if (countRef.current > 0) {
        setCount((count) => count - 1);
      }
    }, 1000);

    return () => clearInterval(timerRef.current);
  }, []);
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 px-8">
      <div className="bg-white rounded-2xl shadow-3xl max-w-md overflow-x-hidden w-full">
        <div className="relative h-[200px]">
          <svg
            width="100%"
            height="200"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="absolute"
          >
            <ellipse cx="50%" cy="0" rx="50%" ry="80%" fill="#E8FBF5" />
          </svg>
          <svg
            width="52"
            height="52"
            viewBox="0 0 52 52"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="absolute left-1/2 top-[50px] -translate-x-1/2"
          >
            <rect x="0.427368" width="52" height="52" rx="26" fill="#0F8560" />
            <path
              d="M16.6774 26.4333L22.8819 32.5L36.1774 19.5"
              stroke="white"
              strokeWidth="3.25"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>

        <div className="font-custom">
          <div className="text-center justify-start text-stone-900 text-xl font-bold">
            Password Reset Successful
          </div>
          <div className="text-center justify-start text-stone-900 text-sm font-medium mt-1">
            Your password has been changed successfully.
          </div>
          <div className="text-center justify-start text-stone-500 text-xs font-medium mt-14 mb-4">
            Redirecting to Login in {count >= 1 ? count : 1}..
          </div>
        </div>
      </div>
    </div>
  );
};

export default PasswordResetSuccessfull;
